import InfoGridValue from './components/InfoGridValue';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const InfoGrid: FunctionComponent<Props> = ({
    ariaLabel,
    className = '',
    fields,
    role,
    testId = TEST_ID
}) => (
    <div
        aria-label={ariaLabel}
        className={`${styles.infoGrid} ${className}`}
        data-testid={testId}
        role={role}
    >
        {fields.map((field, index) => (
            <div
                className={`${styles.field}${field.fullWidth ? ` ${styles.fullWidth}` : ''}${field.thirdWidth ? ` ${styles.thirdWidth}` : ''}`}
                key={index}
            >
                <div className={styles.label}>
                    {field.label}

                    {field.required ? <span className={styles.required}>*</span> : null}
                </div>

                {/* The list position is mixed into the fallback id so two */}
                {/* fields without their own testId don't end up identical. */}
                <InfoGridValue
                    isEmpty={field.empty}
                    testId={field.testId ?? `${TEST_ID}Value${index}`}
                    value={field.value}
                />
            </div>
        ))}
    </div>
);

export default InfoGrid;
